<template>
    <div class="row">

        <div class="col-md-12">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <router-link :to="{name:'home'}">{{$t("inicio")}}</router-link>
                    </li>
                    <li class="breadcrumb-item">
                        <router-link :to="{name:'cajas-online'}">{{$t("cajasOnline")}}</router-link>
                    </li>
                    <li class="breadcrumb-item">
                        <router-link :to="{name:'online-detail', params:{idBusiness: idBusiness}}">
                            {{onlineDetails.nameBusiness}}
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">{{$t("tickets")}}</li>
                </ol>
            </nav>
        </div>


        <div class="col-md-7" style="margin-bottom: 5px">
            <el-button-group>
                <el-button @click="filter('T')" size="small" :class="{'active-filter': filterText == 'T'}"> {{$t("todos")}}
                </el-button>
                <el-button @click="filter('C')" size="small" :class="{'active-filter': filterText == 'C'}"><i
                        class="fas fa-check-circle text-success"></i> {{$t("cobrado")}}
                </el-button>
                <el-button @click="filter('P')" size="small" :class="{'active-filter': filterText == 'P'}"><i
                        class="fas fa-map-pin text-warning"></i> {{$t("apuntado")}}
                </el-button>
                <el-button @click="filter('N')" size="small" :class="{'active-filter': filterText == 'N'}"><i
                        class="fa fa fa-times-circle"
                        style="color: darkred"></i> {{$t("anulado")}}
                </el-button>
                <el-button @click="filter('X')" size="small" :class="{'active-filter': filterText == 'X'}"><i
                        class="fa fa-exchange-alt" style="color: #808000"></i>
                    {{$t("cambio")}}
                </el-button>
                <el-button @click="filter('R')" size="small" :class="{'active-filter': filterText == 'R'}"><i
                        class="fas fa-retweet" style="color: red"></i>
                    Retirada
                </el-button>
                <el-button @click="filter('G')" size="small" :class="{'active-filter': filterText == 'G'}"><i
                        class="fa fa-shopping-cart text-primary"></i> {{$t("gastos")}}
                </el-button>
                <el-button @click="filter('A')" size="small" :class="{'active-filter': filterText == 'A'}"><i
                        class="fas fa fa-clock"></i> {{$t("aparcado")}}
                </el-button>
                <el-button @click="filter('I')" size="small" :class="{'active-filter': filterText == 'I'}"><i
                        class="fas fa-exclamation-circle text-danger"></i>
                    {{$t("incidencias")}}
                </el-button>
            </el-button-group>

        </div>
        <div class="col-md-5" style="margin-bottom: 5px">

            <span><strong>{{$t("filtrarOperario")}}</strong></span>

            <el-select class="select-default"
                       size="large"
                       v-model="filterWorker"
                       filterable
                       @change="filter(null)"
                       :placeholder="$t('seleccionaOperario')">
                <el-option v-for="op in listOperarios"
                           class="select-primary"
                           :value="op.name"
                           :label="op.name +' - '+op.import.toFixed(2)  +' €'"
                           :key="op.name + ' '+parseFloat(op.import.toFixed(2))  +' €'">
                </el-option>
            </el-select>

        </div>

        <div class="col-md-12">
            <template v-for="ticket in tickets">
                <ticket :ticket="ticket"></ticket>
            </template>
        </div>


    </div>
</template>
<script>

    import swal from 'sweetalert2'
    import {
        Switch,
        DatePicker,
        Select,
        Option,
        ButtonGroup,
        Dropdown,
        DropdownItem,
        DropdownMenu,
        Button
    } from 'element-ui'
    import Ticket from '../../Widgets/Ticket.vue'

    export default {
        created() {
            this.$store.dispatch("setNameRoute", "Cajas Online Tickets");
            this.getOnlineDetails();
            
        },
        components: {
            'ticket': Ticket,
            [DatePicker.name]: DatePicker,
            [Select.name]: Select,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [Button.name]: Button,
            [Option.name]: Option,
            [ButtonGroup.name]: ButtonGroup
        },
        data() {
            return {
                idBusiness: this.$route.params.idBusiness,
                onlineDetails: {},
                tickets: [],
                listTickets: [],
                filterText: "T",
                filterWorker: "Todos",
                listOperarios: [],
                conBases:false,
                conExtra:false,
                conOpcionales:false,
            }
        },
        methods: {
             getConfigTpvsub(numConfig) {
            var config = {
                params: {
                  idBusiness: this.idBusiness,
                  jwt: this.$store.getters.jwt,
                  numConfig: numConfig,
                },
                headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };
            let respuesta=false;
            let vm = this;
            this.$store.dispatch("setIdBusiness", this.idBusiness);
            this.axios
                .get(this.$store.getters.apiUrl + "general/getConfigTpv", config)
                .then(function(response) {
                  respuesta = response.data.response;
                  switch(numConfig) {
                    case 95:
                      vm.conBases = respuesta;
                      //console.log("Base "+vm.conBases+" "+numConfig);
                      break;
                    case 96:
                      vm.conOpcionales = respuesta
                      //console.log("Opcional "+vm.conOpcionales+" "+numConfig);
                      break;
                    case 97:
                      vm.conExtra = respuesta;
                      //console.log("Extra "+vm.conExtra+" "+numConfig);
                      break;
                  }

                })
                .catch(function(error) {
                    console.log(error);
                });
            },
            getOnlineDetails() {
                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "online/getOnlineDetails", config)
                    .then(function (response) {
                        if (response.data.response) {
                            vm.onlineDetails = response.data.result;
                            vm.getTickets();
                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            getTickets() {

                var tpvs = [];
                this.onlineDetails.listTpvs.forEach(function (x) {
                    if (x) {
                        tpvs.push(x.idTpv);
                    }
                });


                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        listTpv: JSON.stringify(tpvs),
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };
                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "online/getTickets", config)
                    .then(function (response) {
                        if (response.data.response) {
                            vm.tickets = response.data.result.tickets;
                            vm.listTickets = vm.tickets;


                            vm.extraerOperarios();


                        } else {
                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });
                        }
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },

            extraerOperarios() {

                let xDate = null;
                let vm = this;

                var totalImport = 0;

                this.listTickets.forEach(function (x) {
                    let existe = false;
                    let total = Math.round(x.total * 100) / 100;

                    totalImport += total;

                    xDate = {
                        name: x.workerName,
                        import: total
                    };

                    vm.listOperarios.forEach(function (z) {
                        if (x.workerName === z.name) {
                            existe = true;
                            z.import += total;
                        }
                    });

                    if (!existe) {
                        vm.listOperarios.push(xDate)
                    }

                });

                xDate = {
                    name: "Todos",
                    import: totalImport
                };

                vm.listOperarios.unshift(xDate);

            },
            initChart() {

                var data = [];
                var labels = [];
                var backgroundColors = [];
                var borderColors = [];
                var hoverBackgroundColors = [];

                this.tickets.slice().reverse().forEach(function (x) {
                    if (x.status == "G") {
                        data.push(x.total * (-1));
                    } else {
                        data.push(x.total);
                    }

                    labels.push(x.status);

                    var backgroundColor = "";
                    var borderColor = "";
                    var hoverBackgroundColor = "";


                    switch (x.status) {
                        case "C":
                            backgroundColor = "rgba(0, 128, 64, 0.6)";
                            borderColor = "rgba(0, 128, 64, 0.3)";
                            hoverBackgroundColor = "rgba(0, 128, 64, 1)";
                            break;
                        case "P":
                            backgroundColor = "rgba(255, 128, 0, 0.6)";
                            borderColor = "rgba(255, 128, 0, 0.3)";
                            hoverBackgroundColor = "rgba(255, 128, 0, 1)";
                            break;
                        case "N":
                            backgroundColor = "rgba(128, 0, 0, 0.6)";
                            borderColor = "rgba(128, 0, 0, 0.6)";
                            hoverBackgroundColor = "rgba(128, 0, 0, 1)";
                            break;
                        case "G":
                            backgroundColor = "rgba(0, 64, 128, 0.6)";
                            borderColor = "rgba(0, 64, 128, 0.6)";
                            hoverBackgroundColor = "rgba(0, 64, 128, 1)";
                            break;
                        case "X":
                            backgroundColor = "rgba(128, 128, 0, 0.6)";
                            borderColor = "rgba(128, 128, 0, 0.6)";
                            hoverBackgroundColor = "rgba(128, 128, 0, 1)";
                            break;
                    }

                    backgroundColors.push(backgroundColor);
                    borderColors.push(borderColor);
                    hoverBackgroundColors.push(hoverBackgroundColor);
                });

                new Chart('chart', {
                    type: 'bar',
                    data: {
                        labels: labels,
                        datasets: [{
                            data: data,
                            backgroundColor: backgroundColors,
                            borderColor: borderColors,
                            hoverBackgroundColor: hoverBackgroundColors,
                            borderWidth: 1
                        }]
                    },
                    options: {
                        maintainAspectRatio: false,
                        scales: {
                            yAxes: [{
                                ticks: {
                                    beginAtZero: true
                                }
                            }]
                        },
                        legend: {
                            display: false,
                        }
                    }
                });


            },

            filter(filter) {

                if (filter !== null) {

                    this.filterText = filter;
                }

                let xList = [];
                let vm = this;

                if (this.filterText === "T") {

                    if (this.filterWorker === "Todos") {

                        this.tickets = this.listTickets;

                    }
                    else {

                        this.listTickets.forEach(function (x) {

                            if (x.workerName === vm.filterWorker) {
                                xList.push(x);
                            }

                        });

                        this.tickets = xList;
                    }
                }
                else if (this.filterText === "I") {
                    //TODO
                    if (this.filterWorker === "Todos") {

                        this.listTickets.forEach(function (x) {

                            if (x.numIssues > 0) {

                                xList.push(x);
                            }
                        });

                        this.tickets = xList;

                    }
                    else {

                        this.listTickets.forEach(function (x) {

                            if (x.numIssues > 0 && vm.filterWorker === x.workerName) {

                                xList.push(x);
                            }
                        });

                        this.tickets = xList;

                    }

                }
                else {
                    //TODO

                    if (this.filterWorker === "Todos") {

                        this.listTickets.forEach(function (x) {

                            if (x.status === vm.filterText) {

                                xList.push(x);
                            }
                        });

                        this.tickets = xList;
                    }
                    else {

                        this.listTickets.forEach(function (x) {


                            if (x.status === vm.filterText && x.workerName === vm.filterWorker) {

                                xList.push(x);
                            }
                        });

                        this.tickets = xList;

                    }

                }


            }

        }
    }
</script>
<style scoped>

    .active-filter {
        color: #1E22AA;
        border-color: #b9d0d7;
        background-color: #e8eff2;
    }

    .card-body {
        padding: 10px 15px;
    }

    #tabletotalventa td {
        padding: 5px 15px;
    }

    .wrap-chart {
        margin-top: 10px;
        padding: 0px;
    }

    .foot-total tr td {
        font-size: 1.2em;
        color: #fff;
        text-shadow: 1px 1px #111;
        font-weight: bold;
    }

    .check-tpv {
        padding-left: 1em;
    }

    .check-tpv label {
        margin-bottom: 0px;
    }

    .check-tpv label:hover {
        cursor: pointer;
    }

    .progress {
        height: 10px !important;
        margin-bottom: 0px;
    }

    .progresstpv td {
        border-top: none;
    }

    .card-columns {
        column-count: 2;

    }

    @media (max-width: 767.98px) {
        .card-columns {
            column-count: 1;

        }
    }


</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Online/OnlineTickets.vue